import { ReactNode } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';

interface InventoryDataTableCardProps {
  loading: boolean;
  isEmpty: boolean;
  colSpan: number;
  emptyMessage: string;
  header: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

/** Card-wrapped data table with shared loading / empty states. */
export function InventoryDataTableCard({
  loading,
  isEmpty,
  colSpan,
  emptyMessage,
  header,
  children,
  footer,
}: InventoryDataTableCardProps) {
  return (
    <Card>
      <Table>
        <TableHeader>
          <TableRow>{header}</TableRow>
        </TableHeader>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={colSpan} className="py-8 text-center text-muted-foreground">
                Loading…
              </TableCell>
            </TableRow>
          ) : isEmpty ? (
            <TableRow>
              <TableCell colSpan={colSpan} className="py-8 text-center text-muted-foreground">
                {emptyMessage}
              </TableCell>
            </TableRow>
          ) : (
            children
          )}
        </TableBody>
      </Table>
      {footer}
    </Card>
  );
}

export function InventoryTableHead(props: React.ComponentProps<typeof TableHead>) {
  return <TableHead {...props} />;
}
